export const normalizeWarehouse = (w) => String(w || "").trim() || "SIN_ALMACEN";

export const getCartLineKey = (item) =>
  item?.lineKey || `${item?.code}::${normalizeWarehouse(item?.warehouse)}`;
